import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { serviceName } from '../base.js';
export const whiteLabelServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const WhiteLabelServiceEventBaseSchema = EventBaseSchema.extend({
    type: whiteLabelServiceEventType(),
});
